import { render, staticRenderFns } from "./AdminPanelBaskets.vue?vue&type=template&id=5a8d532c&scoped=true"
import script from "./AdminPanelBaskets.vue?vue&type=script&lang=js"
export * from "./AdminPanelBaskets.vue?vue&type=script&lang=js"
import style0 from "./AdminPanelBaskets.vue?vue&type=style&index=0&id=5a8d532c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8d532c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
